import React from 'react'

const VehicleListHeader = () => {
  return (
    <div>
        <h1 className='uppercase text-center py-14 text-2xl md:text-3xl font-bold'>Vehicle List</h1>
    </div>
  )
}

export default VehicleListHeader